import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { AddToolTip, SliderPanel } from "../../../components";
import {
  getPathWithParam,
  MANAGE_PLAN_ROUTES,
  maskedBankAccountNumberNormalizer,
} from "../../../utils";
import DeleteSponsorBankAccountCard from "./DeleteSponsorBankAccountCard";
import SponsorSlider from "./SponsorSlider";
import { useRouterParams } from "../../../abstracts";
import { useHistory } from "react-router";

const SponsorBankSavedSlider = ({
  openSlider,
  setOpenSlider,
  setOuterValues,
  outerValues,
  open,
  setOpen,
  Id,
  setId,
  fundingId,
  planCashToggle,
  forfeitureToggle,
  achToggle,
}) => {
  const [deleteCard, setDeleteCard] = useState(false);
  var { flow, planId } = useRouterParams();
  const [cancelButtonInsideCard, setCancelButtonInsideCard] = useState(false);
  const history = useHistory();
  var SponsorSavedData = outerValues?.Data?.filter(
    (item, ind) => item.id === Id
  );
  var bankName;
  {
    SponsorSavedData?.map((item, ind) => (bankName = item.bankAccountName));
  }

  const onCloseHandler = () => {
    setOpenSlider(!openSlider);
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
        pathParam: [flow, planId],
      })
    );
  };

  const onEditHandler = (id) => {
    setOpen(true);
    // setCommonState(true)
    // history.push(
    //   getPathWithParam({
    //     path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
    //     pathParam: [flow, planId, id],
    //   })
    // );
  };

  return (
    <>
      {open && (
        <SponsorSlider
          Id={Id}
          setId={setId}
          open={open}
          setOpen={setOpen}
          setOuterValues={setOuterValues}
          outerValues={outerValues}
          openSlider={openSlider}
          setOpenSlider={setOpenSlider}
          fundingId={fundingId}
          planCashToggle={planCashToggle}
          forfeitureToggle={forfeitureToggle}
          achToggle={achToggle}
        />
      )}

      <SliderPanel
        isOpen={openSlider}
        showCancelButton={false}
        showSave={false}
        showCancel={true}
        showBackButton={true}
        backdropClicked={true}
        onClose={() => onCloseHandler()}
        title={"Add New Section"}
        size={38}
        showHeader={true}
        header={"Sponsor bank account Details"}
        headerClass="slider-title-case"
      >
        <div
        // style={{
        //   display: "grid",
        //   gridTemplateColumns: "4fr 1fr 1fr",
        //   gridGap: "20px",
        //   // marginLeft: "20px",
        // }}
        >
          {/* <p className="SponsorSliderHeader">sponsor bank account Details</p> */}

          {deleteCard === false && (
            <>
              <Button
                // className="deleteCardButton w-200px"
                style={{ marginLeft: "15rem" }}
                variant="secondary"
                onClick={() => setDeleteCard(true)}
              >
                Delete
              </Button>
              <Button
                // className="deleteCardButton"
                style={{ marginLeft: "1rem" }}
                onClick={() => {
                  onEditHandler(Id);
                }}
              >
                Edit
              </Button>
            </>
          )}

          {/* <hr
            style={{
              marginTop: "-60px",
              width: "170%",
              border: "0.25px solid #e0e0e0",
            }}
          /> */}
        </div>
        <br></br>
        {open && openSlider && (
          <SponsorSlider
            Id={Id}
            setId={setId}
            open={open}
            setOpen={setOpen}
            setOuterValues={setOuterValues}
            outerValues={outerValues}
            openSlider={openSlider}
            setOpenSlider={setOpenSlider}
            fundingId={fundingId}
            planCashToggle={planCashToggle}
            forfeitureToggle={forfeitureToggle}
            achToggle={achToggle}
          />
        )}

        {deleteCard && (
          <DeleteSponsorBankAccountCard
            bankName={bankName}
            deleteCard={deleteCard}
            setDeleteCard={setDeleteCard}
            openSlider={openSlider}
            setOpenSlider={setOpenSlider}
            cancelButtonInsideCard={cancelButtonInsideCard}
            setCancelButtonInsideCard={setCancelButtonInsideCard}
            Id={Id}
            setId={setId}
            outerValues={outerValues}
            setOuterValues={setOuterValues}
          />
        )}

        {SponsorSavedData?.map((x, ind) => {
          return (
            <div className={deleteCard ? "withCard" : "withoutCard"}>
              <p className="SponsorHeader">Bank name</p>
              {/* <AddToolTip>{x.bankAccountName.slice(0, 25)}...</AddToolTip> */}

              {x?.bankAccountName?.length > 25 ? (
                <AddToolTip name={x.bankAccountName}>
                  {(x.bankAccountName || "").slice(0, 25)}...
                </AddToolTip>
              ) : (
                <div>{x.bankAccountName}</div>
              )}
              <p className="SponsorHeader">Default Account</p>
              <p className="SponsorValue">
                {x.defaultBankAccountIndicator === true ? "Yes" : "No"}
              </p>

              <p className="SponsorHeader">Bank Account Number</p>
              <p className="SponsorValue">
                {maskedBankAccountNumberNormalizer(x.bankAccountNumber)}
              </p>

              <p className="SponsorHeader">Aba Routing Number</p>
              <p className="SponsorValue">{x.abaRoutingNumber}</p>

              <p className="SponsorHeader">Saving Account Type</p>
              <p className="SponsorValue">
                {x.bankAccountType === 1 ? "Savings" : "Current"}
              </p>

              <p className="SponsorHeader">Status</p>
              <p className="SponsorValue">
                {x.bankAccountStatus === 1 ? "Active" : "InActive"}
              </p>
            </div>
          );
        })}
      </SliderPanel>
    </>
  );
};

export default SponsorBankSavedSlider;
